const initTabs = () => {
    const tabBlocks = document.querySelectorAll('.blockTabs')

    tabBlocks.forEach((block) => {
        const buttons = block.querySelectorAll('[data-tabs-button]')
        const images = block.querySelectorAll('.js-tabs-image')

        buttons.forEach((button, index) => {
            button.addEventListener('click', () => {
                buttons.forEach((item) => item.classList.remove('active'))
                images.forEach((image) => image.classList.remove('active'))

                button.classList.add('active')
                images[index]?.classList.add('active')
            })
        })
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs)
} else {
    initTabs()
}
